import { FormGroup, Input, Label } from "reactstrap";

const FormTextArea = ({
	formLabel,
	placeholder,
	type = "text",
	appendText,
	error,
	register = () => {},
	editable = true,
	name,
	required = false,
	className,
	additionalOptions = {},
	validation = {},
	transformations = {},
	light = false,
	readOnly = false,
	disabled = false,
	prefix = "",
	alt = "",
	requiredErrorMessage = undefined,
}) =>
	editable ? (
		<div className="mb-3 w-100">
			<FormGroup>
				<Label className="text-white ml-2">{formLabel}</Label>
				<textarea
					className={`form-control ${Boolean(error) && "is-invalid"} text-white`}
					{...register(prefix + "." + name, {
						required: required
							? {
									value: true,
									message: requiredErrorMessage ? requiredErrorMessage : `${formLabel} is required`,
							  }
							: false,
						...validation,
						...transformations,
						...additionalOptions,
					})}
					disabled={disabled || readOnly}
				/>
			</FormGroup>
			{error && (
				<div className="text-center">
					<small className="text-danger">{error?.message}</small>
				</div>
			)}
		</div>
	) : (
		<div className="mb-3 w-100">
			<div className="row">
				<div className={`${light && "text-dark"} col-sm-3 col-md-2 text-left mb-1 text-light font-weight-bold`}>{formLabel}</div>
				<div className="col-sm-9 col-md-10 text-info">{alt}</div>
			</div>
		</div>
	);

export default FormTextArea;
